module.exports = __webpack_public_path__ + "static/image/font/pc/bmjua-1@3x.ver2_0_2.jpg?f3d61349";